import React from "react";
import { connect } from "react-redux";

import Panel from "../core/components/panels/Panel";
import PanelContainer from "../core/components/panels/PanelContainer";
import ActivityList from "../core/components/admin/ActivityList";
import RecommendationList from "../core/components/admin/RecommendationList";
// import { TTSChartProps } from "../core/components/charts/Chart";

import { IAppState } from "../core/state/Store";
import { initialiseActivity } from "../core/state/administration/Activity";
import PageSpecification from "../core/types/system/PageSpecification";
import {
    getAccessLogPage,
    setAccessLogPageAndSize,
} from "../core/state/system/AccessLog";
import Grid from "../core/components/grid/Grid";
import GridColumn, { GridColumnType } from "../core/components/grid/GridColumn";
import AccessLog from "../core/types/system/AccessLog";
import { CreatePermissionSet } from "../core/state/core/User";

import { unwrappedDispatch } from "../core/foundation/Dispatching";
import UserActivityLogin from "../core/types/admin/UserActivityLogin";
import PermissionSet, {
    PermissionsType,
} from "../core/types/core/PermissionSet";
import GeneralContainer from "../core/components/containers/GeneralContainer";
import { setRouteDisplay } from "../core/state/system/Display";
import { Alignment, Side, Size } from "../core/types/system/Layout";
import { initialiseClientSystems } from "../core/state/core/ClientSystem";
import ClientSystem from "../core/types/core/ClientSystem";
import { AppContext } from "../core/types/system/AppContext";
import {
    fetchDashboardActivities,
    fetchDashboardContacts,
    getDashboardUpload,
    initialiseDashboardDetails,
} from "../core/state/core/Dashboard";
import Dashboard, {
    DashboardActivity,
    DashboardContact,
    DashboardWidget,
    DashboardWidgetFile,
    DashboardWidgetType,
    DashboardWidgetUrl,
} from "../core/types/core/Dashboard";
import Text from "../core/components/text/Text";
import Utility from "../core/foundation/Utility";
import List from "../core/components/list/List";
import ListItem from "../core/components/list/ListItem";
import User from "../core/types/core/User";

import v9Icon from "../core/graphics/Version9Icon_64.png";
import v10Icon from "../core/graphics/V10-Logo_1.png";
import banner from "../resources/training-banner-bg.jpg";

import "./Welcome.scss";
import { setPageLoading } from "../core/state/system/UIConfiguration";
import { checkUrl, getCheckResultMessage } from "../core/state/system/Urls";
import { addAlert } from "../core/state/system/Alerts";
import Info from "../core/components/info/Info";
import { initialiseUserDetails } from "../core/state/system/Session";

interface RouteWelcomeProps {
    users: User[];
    dashboard: Dashboard;
    dashboardBanner: string;
    activityStatus: string;
    loginsStatus: string;
    activityLogins?: UserActivityLogin;
    permissions?: PermissionSet;
    accessLogPageData?: any[];
    accessLogSpecification?: PageSpecification;
    accessLogStatus: string;
    liveSystems: ClientSystem[];
    liveStatus: string;

    setPageLoading: (loading: boolean) => void;
    initialiseDashboardDetails: () => void;
    initialiseActivity: () => void;
    initialiseUserDetails: () => void;
    initialiseClientSystems: () => void;
    getAccessLogPage: () => void;
    setRouteDisplay: (types: string[]) => void;
    setAccessLogPageAndSize: (specification: PageSpecification) => void;
}

interface RouteWelcomeState {
    selectedOption: string;
    dashboardBanner: string;
}

// interface ChartData {
//     statusConfig: TTSChartProps;
//     browserConfig: TTSChartProps;
// }

class RouteWelcome extends React.Component<
    RouteWelcomeProps,
    RouteWelcomeState
> {
    static contextType = AppContext;
    context!: React.ContextType<typeof AppContext>;

    state: RouteWelcomeState = {
        selectedOption: "Option 1",
        dashboardBanner: null,
    };

    async componentDidMount() {
        await Promise.all([
            this.props.initialiseDashboardDetails(),
            this.props.initialiseActivity(),
            this.props.initialiseUserDetails(),
            this.props.initialiseClientSystems(),
            this.props.getAccessLogPage(),
        ]);

        if (!!this.props.dashboardBanner && !!this.props.dashboard)
            this.setBanner();
    }

    componentDidUpdate(
        prevProps: Readonly<RouteWelcomeProps>,
        prevState: Readonly<RouteWelcomeState>,
        snapshot?: any,
    ) {
        if (
            prevProps.dashboardBanner !== this.props.dashboardBanner &&
            !!this.props.dashboard
        )
            this.setBanner();
    }

    async setBanner() {
        const banner = (
            this.props.dashboard?.banner?.style === "cover"
                ? this.props.dashboardBanner
                : await Utility.cropImage(this.props.dashboardBanner, {
                      width: 2200,
                      height: 360,
                      radius: 20,
                  })
        ).toDataUrl();

        this.setState({
            dashboardBanner: `url(${banner})`,
        });
    }

    async getBanner() {
        if (this.state.dashboardBanner) return this.state.dashboardBanner;

        return null;
    }

    // processLoginData(): ChartData {
    //     let result = {
    //         statusConfig: {
    //             labels: [],
    //             datasets: [
    //                 {
    //                     label: "",
    //                     data: [],
    //                 },
    //             ],
    //         },
    //         browserConfig: {
    //             labels: [],
    //             datasets: [
    //                 {
    //                     label: "",
    //                     data: [],
    //                 },
    //             ],
    //         },
    //     } as ChartData;

    //     if (this.props.activityLogins) {
    //         for (let key of Object.keys(this.props.activityLogins.states)) {
    //             result.statusConfig.labels.push(key);
    //             result.statusConfig.datasets[0].data.push(
    //                 this.props.activityLogins.states[key],
    //             );
    //         }

    //         for (let key of Object.keys(this.props.activityLogins.browsers)) {
    //             result.browserConfig.labels.push(key);
    //             result.browserConfig.datasets[0].data.push(
    //                 this.props.activityLogins.browsers[key],
    //             );
    //         }
    //     }

    //     return result;
    // }

    render() {
        let permissions = this.props.permissions
            ? CreatePermissionSet(this.props.permissions)
            : null;
        // let accessSchools = permissions?.canMultiRead(PermissionsType.School) ?? false;
        // let accessEmails = permissions?.canRead(PermissionsType.EmailSettings) ?? false;
        // let accessIntegrations = permissions?.canAdminRead(PermissionsType.Integration) ?? false;
        let accessUsers =
            permissions?.canAdminRead(PermissionsType.Users) ?? false;

        return (
            <section>
                {this.props.dashboard?.banner?.enabled && (
                    <GeneralContainer
                        scaling={true}
                        max={true}
                        alignment={Alignment.Center}
                        clearanceSide={Side.Top}
                        clearanceSize={Size.Large}>
                        <Panel
                            style={{
                                minHeight: "75px",
                                height: this.state.dashboardBanner
                                    ? "220px"
                                    : null,
                                backgroundPosition: "center top",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "cover",
                                backgroundImage:
                                    this.props.dashboard?.banner?.style ===
                                    "cover"
                                        ? this.state.dashboardBanner
                                            ? this.state.dashboardBanner
                                            : undefined
                                        : undefined,
                                backgroundColor: this.state.dashboardBanner
                                    ? this.props.dashboard?.banner?.colour
                                    : undefined,
                            }}>
                            {this.state.dashboardBanner &&
                                this.props.dashboard?.banner?.style ===
                                    "contain" && (
                                    <GeneralContainer
                                        style={{
                                            height: this.state.dashboardBanner
                                                ? "200px"
                                                : null,
                                            backgroundPosition: "center top",
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "contain",
                                            backgroundImage: this.state
                                                .dashboardBanner
                                                ? this.state.dashboardBanner
                                                : undefined,
                                        }}
                                    />
                                )}
                        </Panel>
                    </GeneralContainer>
                )}

                <GeneralContainer
                    scaling={true}
                    max={true}
                    alignment={Alignment.Center}
                    clearanceSide={Side.Top}>
                    <PanelContainer>
                        {accessUsers && (
                            <>
                                <Panel
                                    title="User Sessions"
                                    size="large"
                                    containContent={true}>
                                    <ActivityList></ActivityList>
                                </Panel>

                                <Panel
                                    title="Recent Logins"
                                    size="large"
                                    gridContent={true}
                                    loading={
                                        this.props.accessLogStatus !==
                                        "succeeded"
                                    }>
                                    <Grid<AccessLog>
                                        value={this.props.accessLogPageData}
                                        keyField="id"
                                        defaultSortField="-created"
                                        fullWidth={true}
                                        rounded={true}
                                        limitTo={10}
                                        onPageChange={
                                            this.props.setAccessLogPageAndSize
                                        }>
                                        <GridColumn
                                            header="Username"
                                            field="user"
                                            selectable={true}
                                        />
                                        <GridColumn
                                            header="Location"
                                            field="location"
                                            selectable={true}
                                        />
                                        <GridColumn
                                            header="App"
                                            field="application"
                                            selectable={true}
                                        />
                                    </Grid>
                                </Panel>
                            </>
                        )}

                        <Panel
                            title="Recommendations"
                            size="large"
                            moreButtonText="All Recommendations"
                            moreButtonOnClick={() =>
                                this.context.navigate("/recommendations")
                            }>
                            <RecommendationList></RecommendationList>
                        </Panel>
                    </PanelContainer>

                    {this.props.dashboard?.widgets?.filter(
                        widget => widget.enabled,
                    )?.length && (
                        <PanelContainer>
                            {this.props.dashboard?.widgets
                                ?.filter(widget => widget.enabled)
                                ?.map((widget, index) => (
                                    <ConnectedWidgetDisplay
                                        key={index}
                                        widget={widget}
                                        users={this.props.users}
                                        onLoadingChange={loading =>
                                            this.props.setPageLoading(loading)
                                        }
                                    />
                                ))}
                        </PanelContainer>
                    )}

                    <PanelContainer>
                        <Panel
                            title="Timetabling Solutions V10"
                            size="medium"
                            uniform={true}
                            icon={v10Icon}
                            moreButtonText="Product Page"
                            moreButtonOnClick={() =>
                                this.context.navigate("/version10")
                            }>
                            Timetabling Solutions V10 is our latest
                            full-featured desktop software for timetabling your
                            school.
                        </Panel>

                        <Panel
                            title="Timetabling Solutions V9"
                            size="medium"
                            uniform={true}
                            icon={v9Icon}
                            moreButtonText="Product Page"
                            moreButtonOnClick={() =>
                                this.context.navigate("/version9")
                            }>
                            Timetabling Solutions V9 is the previous desktop
                            software version which is now unsupported however we
                            will maintain access to it for compatibility
                            reasons.
                        </Panel>
                    </PanelContainer>

                    <PanelContainer>
                        <Panel
                            size="medium"
                            iconFont="book-open-reader"
                            iconFontColor="blue"
                            moreButtonText="View Now"
                            moreButtonOnClick={() =>
                                window.open(
                                    "https://www.timetabling.com.au/training/timetabling-training",
                                )
                            }>
                            <div
                                className="has-background"
                                style={{
                                    background: `url(${banner}) no-repeat center center`,
                                    backgroundSize: "cover",
                                    minHeight: "300px",
                                }}>
                                <div className="header bottom-clearance">
                                    <div className="title">
                                        Timetabling Training
                                    </div>
                                </div>
                                <div className="text-center center media-title">
                                    At Timetabling Solutions Training Courses,
                                    the emphasis is on hands-on learning. Each
                                    Training Course includes a comprehensive
                                    training manual with sample data. Course
                                    materials are enhanced and updated on a
                                    regular basis and correspond with the
                                    current product version.
                                </div>
                            </div>
                        </Panel>
                    </PanelContainer>
                </GeneralContainer>

                <GeneralContainer
                    scaling={true}
                    max={true}
                    alignment={Alignment.Center}
                    clearanceSide={Side.Vertical}>
                    <PanelContainer>
                        <Panel title="Applications">
                            <Grid<ClientSystem>
                                value={this.props.liveSystems}
                                keyField="id"
                                fullWidth={true}
                                rounded={true}>
                                <GridColumn
                                    header="Subscriptions"
                                    field="name"
                                    selectable={true}
                                />
                                <GridColumn
                                    header=""
                                    field=""
                                    icon="help_outline"
                                    cellTooltipField="description"
                                    width="40px"
                                />
                                <GridColumn
                                    header="User Limits"
                                    field="licenceCountDisplay"
                                    selectable={true}
                                    type={GridColumnType.Number}
                                />
                                <GridColumn
                                    header="Users Assigned"
                                    field="roleAllocations"
                                    selectable={true}
                                    type={GridColumnType.Number}
                                />
                                <GridColumn
                                    header="Options"
                                    field="link"
                                    selectable={true}
                                    type={GridColumnType.Html}
                                />
                                <GridColumn
                                    header="Renews"
                                    field="expiryDate"
                                    selectable={true}
                                    type={GridColumnType.Date}
                                />
                            </Grid>
                        </Panel>
                    </PanelContainer>
                </GeneralContainer>
            </section>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const { activity, user, accessLog, clientSystem, dashboard } = state.db;
    const { session } = state.session;
    return {
        users: user.allUsers,
        dashboard: dashboard.dashboard,
        dashboardBanner: dashboard.dashboardBanner,
        activityStatus: activity.activityStatus,
        loginsStatus: activity.loginsStatus,
        activityLogins: activity.activityLogins,
        permissions: session.permissions,
        accessLogPageData: accessLog.pageData,
        accessLogSpecification: accessLog.virtualSpec,
        accessLogStatus: accessLog.status,
        liveSystems: clientSystem.liveSystems,
        liveStatus: clientSystem.liveStatus,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setPageLoading: (loading: boolean) => dispatch(setPageLoading(loading)),
        initialiseDashboardDetails: () =>
            unwrappedDispatch(initialiseDashboardDetails()),
        initialiseActivity: () => unwrappedDispatch(initialiseActivity()),
        initialiseUserDetails: () => unwrappedDispatch(initialiseUserDetails()),
        initialiseClientSystems: () => initialiseClientSystems(),
        getAccessLogPage: () => unwrappedDispatch(getAccessLogPage()),
        setRouteDisplay: (types: string[]) =>
            unwrappedDispatch(setRouteDisplay(types)),
        setAccessLogPageAndSize: (specification: PageSpecification) =>
            unwrappedDispatch(setAccessLogPageAndSize(specification)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RouteWelcome);

interface WidgetDisplayProps {
    users: User[];
    widget: DashboardWidget;
    activities: DashboardActivity[];
    activityStatus: string;
    contacts: DashboardContact[];
    contactStatus: string;

    onLoadingChange?: (loading: boolean) => void;
    fetchDashboardActivities: () => Promise<DashboardActivity[]>;
    fetchDashboardContacts: () => Promise<DashboardContact[]>;
}

class WidgetDisplay extends React.Component<WidgetDisplayProps> {
    componentDidMount(): void {
        if (this.props.widget.type === DashboardWidgetType.Activities)
            this.props.fetchDashboardActivities();
        if (this.props.widget.type === DashboardWidgetType.Contacts)
            this.props.fetchDashboardContacts();
    }

    isLoading() {
        return (
            (this.props.widget?.type === DashboardWidgetType.Activities &&
                (this.props.activityStatus ?? "idle") === "loading") ||
            (this.props.widget?.type === DashboardWidgetType.Contacts &&
                (this.props.contactStatus ?? "idle") === "loading")
        );
    }

    render() {
        return (
            <Panel
                title={this.props.widget.name}
                size="medium"
                className="half"
                loading={this.isLoading()}>
                {this.props.widget.type === DashboardWidgetType.Contacts &&
                    (this.props.contacts?.length ? (
                        <List>
                            {this.props.contacts.map(
                                (contact, contactIndex) => (
                                    <WidgetContactDisplay
                                        key={contactIndex}
                                        users={this.props.users}
                                        contact={contact}
                                    />
                                ),
                            )}
                        </List>
                    ) : (
                        <Text>There are no contacts listed</Text>
                    ))}

                {this.props.widget.type === DashboardWidgetType.Files &&
                    (this.props.widget.files.length ? (
                        <List>
                            {this.props.widget.files.map((file, fileIndex) => (
                                <ConnectedWidgetFileDisplay
                                    key={fileIndex}
                                    file={file}
                                    onLoadingChange={this.props.onLoadingChange}
                                />
                            ))}
                        </List>
                    ) : (
                        <Text>There are no files listed</Text>
                    ))}

                {this.props.widget.type === DashboardWidgetType.Urls &&
                    (this.props.widget.urls.length ? (
                        <List>
                            {this.props.widget.urls.map((url, urlIndex) => (
                                <WidgetUrlDisplay
                                    key={urlIndex}
                                    url={url}
                                />
                            ))}
                        </List>
                    ) : (
                        <Text>There are no URLs listed</Text>
                    ))}

                {this.props.widget.type === DashboardWidgetType.Activities && (
                    <>
                        <Info clearanceSide={Side.Bottom}>
                            Organiser Activities - 3 Month Outlook
                        </Info>

                        {this.props.activities?.length ? (
                            <List>
                                {this.props.activities?.map(
                                    (activity, activityIndex) => (
                                        <WidgetActivityDisplay
                                            key={activityIndex}
                                            activity={activity}
                                        />
                                    ),
                                )}
                            </List>
                        ) : (
                            <Text>There are no activities listed</Text>
                        )}
                    </>
                )}
            </Panel>
        );
    }
}

const mapWidgetStateToProps = (state: IAppState) => {
    const { dashboard } = state.db;
    return {
        activities: dashboard.activities,
        activityStatus: dashboard.activityStatus,
        contacts: dashboard.contacts,
        contactStatus: dashboard.contactStatus,
    };
};

const mapWidgetDispatchToProps = () => {
    return {
        fetchDashboardActivities: () =>
            unwrappedDispatch(fetchDashboardActivities()),
        fetchDashboardContacts: () =>
            unwrappedDispatch(fetchDashboardContacts()),
    };
};

const ConnectedWidgetDisplay = connect(
    mapWidgetStateToProps,
    mapWidgetDispatchToProps,
)(WidgetDisplay);

interface WidgetContactDisplayProps {
    users: User[];
    contact: DashboardContact;
}

class WidgetContactDisplay extends React.Component<WidgetContactDisplayProps> {
    onClick() {
        window.location.href = `mailto:${encodeURIComponent(
            this.props.contact.contact +
                "(" +
                this.props.contact.firstName +
                " " +
                this.props.contact.lastName +
                ")",
        )}?subject=${encodeURIComponent(
            "Timetabling Solutions Contact: " + this.props.contact.type,
        )}`;
    }

    render() {
        return (
            <ListItem
                slim={true}
                tooltip="Send email"
                tooltipSide="top"
                onClick={this.onClick.bind(this)}>
                <i>person</i>
                <span>
                    {this.props.contact.type}
                    :&nbsp;
                    {this.props.contact?.firstName}&nbsp;
                    {this.props.contact?.lastName} (
                    {this.props.contact?.contact})
                </span>
            </ListItem>
        );
    }
}

interface WidgetFileDisplayProps {
    file: DashboardWidgetFile;

    onLoadingChange?: (loading: boolean) => void;
    getDashboardUpload: (uploadID: string) => Promise<string>;
}

class WidgetFileDisplay extends React.Component<WidgetFileDisplayProps> {
    async onClick() {
        if (!this.props.file.storageToken) return;

        try {
            if (this.props.onLoadingChange) this.props.onLoadingChange(true);

            const response = await this.props.getDashboardUpload(
                this.props.file.storageToken,
            );

            if (response) response.download(this.props.file.fileName);
        } finally {
            if (this.props.onLoadingChange) this.props.onLoadingChange(false);
        }
    }

    render() {
        return (
            <ListItem
                slim={true}
                tooltip="Download file"
                tooltipSide="top"
                onClick={this.onClick.bind(this)}>
                <i>description</i>
                <span>{this.props.file.displayName}</span>
            </ListItem>
        );
    }
}

const mapFileStateToProps = (state: IAppState) => {
    return {};
};

const mapFileDispatchToProps = () => {
    return {
        getDashboardUpload: (uploadID: string) =>
            unwrappedDispatch(getDashboardUpload(uploadID)),
    };
};

const ConnectedWidgetFileDisplay = connect(
    mapFileStateToProps,
    mapFileDispatchToProps,
)(WidgetFileDisplay);

interface WidgetUrlDisplayProps {
    url: DashboardWidgetUrl;

    onLoadingChange?: (loading: boolean) => void;
}

class WidgetUrlDisplay extends React.Component<WidgetUrlDisplayProps> {
    async onClick() {
        try {
            this.props.onLoadingChange?.(true);

            const checkResult = await this.checkUrl(this.props.url.url);

            if (!!checkResult)
                addAlert({
                    icon: "error",
                    styleColor: "red",
                    title: "Unable to open URL",
                    text: checkResult,
                });
            else window.open(this.props.url.url, "_blank");
        } finally {
            this.props.onLoadingChange?.(false);
        }
    }

    async checkUrl(url: string) {
        if (!Utility.isValidHttpUrl(url)) {
            return "Please use a valid Url";
        }

        const checkResults = await checkUrl(url);
        if (checkResults.length > 0) {
            return `${getCheckResultMessage(
                checkResults,
            )}, please notify your school administrator of this unsafe content.`;
        }

        return null;
    }

    render() {
        return (
            <ListItem
                slim={true}
                tooltip={`Open URL`}
                tooltipSide="top"
                onClick={this.onClick.bind(this)}>
                <i>link</i>
                <span>{this.props.url.urlName}</span>
            </ListItem>
        );
    }
}

interface WidgetActivityDisplayProps {
    activity: DashboardActivity;
}

class WidgetActivityDisplay extends React.Component<WidgetActivityDisplayProps> {
    render() {
        return (
            <ListItem
                slim={true}
                tooltip="Download file"
                tooltipSide="top">
                <i>event</i>
                <span>
                    {this.props.activity.name}:&nbsp;
                    {this.props.activity.activityStart
                        .toDate()
                        .toLocaleShortDate()}
                    &nbsp;-&nbsp;
                    {this.props.activity.activityEnd
                        .toDate()
                        .toLocaleShortDate()}
                </span>
            </ListItem>
        );
    }
}
